// Hides the sticky header while scrolling down and reveals it on any upward scroll.
class SScrollHeader extends HTMLElement {
  #controller = null;
  #lastY = 0;
  #ticking = false;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#lastY = Math.max(window.scrollY, 0);

    window.addEventListener(
      'scroll',
      () => {
        if (this.#ticking) return;
        this.#ticking = true;
        requestAnimationFrame(() => {
          this.#update();
          this.#ticking = false;
        });
      },
      { passive: true, signal }
    );

    // Keyboard users tabbing into the header always get it back.
    this.addEventListener('focusin', () => this.#show(), { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #update() {
    const y = Math.max(window.scrollY, 0);
    const delta = y - this.#lastY;
    // Ignore tiny jitters (trackpads, iOS bounce) so the header doesn't flicker.
    if (Math.abs(delta) < 8) return;

    const pastHeader = y > this.offsetHeight;
    const dialogOpen = this.querySelector('dialog[open]');

    if (delta > 0 && pastHeader && !dialogOpen) {
      this.setAttribute('data-hidden', '');
    } else if (delta < 0) {
      this.#show();
    }
    this.#lastY = y;
  }

  #show() {
    this.removeAttribute('data-hidden');
  }
}

if (!customElements.get('s-scroll-header')) {
  customElements.define('s-scroll-header', SScrollHeader);
}
